import React from "react";
import styles from "../SubjectSinglePage.module.css";
import type { SubjectItem, VisibleSubjectRow } from "../model/types";

type SubjectChooserDrawerProps = {
  drawerOpen: boolean;
  selectedSubject: SubjectItem | null;
  visibleSubjectRows: VisibleSubjectRow[];
  renderSubjectSearch: (label: string) => React.ReactNode;
  renderSubjectSearchEmpty: () => React.ReactNode;
  renderSubjectRow: (subject: SubjectItem, depth: number) => React.ReactNode;
  onToggleDrawer: () => void;
  onCloseDrawer: () => void;
  onSubjectTreeKeyDown: (event: React.KeyboardEvent) => void;
};

export const SubjectChooserDrawer: React.FC<SubjectChooserDrawerProps> = ({
  drawerOpen,
  selectedSubject,
  visibleSubjectRows,
  renderSubjectSearch,
  renderSubjectSearchEmpty,
  renderSubjectRow,
  onToggleDrawer,
  onCloseDrawer,
  onSubjectTreeKeyDown,
}) => (
  <>
    {selectedSubject && (
      <button
        type="button"
        className={styles.drawerToggle}
        aria-label={drawerOpen ? "Hide subject chooser" : "Open subject chooser"}
        aria-expanded={drawerOpen}
        onClick={onToggleDrawer}
      >
        {drawerOpen ? "‹" : "»"}
      </button>
    )}

    {drawerOpen && selectedSubject && (
      <aside className={styles.drawer} aria-label="Subject chooser drawer">
        <div className={styles.drawerHeader}>
          <strong>Subjects</strong>
          <button
            type="button"
            onClick={onCloseDrawer}
            aria-label="Close subject chooser"
          >
            ×
          </button>
        </div>
        {renderSubjectSearch("Search subjects in drawer tree")}
        <div
          className={styles.drawerList}
          role="tree"
          aria-label="Subjects drawer tree"
          onKeyDown={onSubjectTreeKeyDown}
        >
          {visibleSubjectRows.length
            ? visibleSubjectRows.map((row) =>
                renderSubjectRow(row.subject, row.depth),
              )
            : renderSubjectSearchEmpty()}
        </div>
      </aside>
    )}
  </>
);
